/* External dependencies */
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import get from 'lodash/get';

/* Internal dependencies */
import Icon, { Icons } from '../icon/Icon';
import { ApplicationState } from '../store';
import { CurrentUserState, getCurrentUser } from '../store/ducks/currentUser';
import Analytics, { AnalyticsEventType } from '../analytics/Analytics';
import { CurrentProfileState, getCurrentProfile } from '../store/ducks/currentProfile';
import Button from 'src/button/Button';
import CreateFeedPostDrawerButton from 'src/feedPost/CreateFeedPostDrawerButton';
import CreateGigButton from 'src/artist/manage/CreateGigButton';
import Artist from 'src/types/Artist';

type InjectedProps = {
  history: any;
};

type OwnProps = {
  selectedFeed?: Object; // Event or Community
  hiddenOptions?: CreateOptionId[];
};

type StateProps = {
  currentUser: CurrentUserState;
  currentProfile: CurrentProfileState;
};

type Props = InjectedProps & OwnProps & StateProps;

type State = {
  createDrawerOpen: boolean;
  communitiesFeature: boolean;
};

export enum CreateOptionId {
  event = 'event',
  post = 'post',
  plan = 'plan',
  chat = 'chat',
  community = 'community',
  gig = 'gig',
}

class CreateButton extends React.Component<Props,State> {
  state = { createDrawerOpen: false, communitiesFeature: false };

  openCreateDrawer = () => {
    this.setState({ createDrawerOpen: true });
    Analytics.track(AnalyticsEventType.createDrawerOpened);
  };

  closeCreateDrawer = () => {
    this.setState({ createDrawerOpen: false });
    Analytics.track(AnalyticsEventType.createDrawerClosed);
  };

  render() {
    const {
      currentUser, currentProfile,
      selectedFeed,
      history, hiddenOptions = [],
    } = this.props;
    const profile = currentProfile || currentUser;
    const profileType = get(profile, 'type');

    if (profileType === 'artist') {
      hiddenOptions.push(CreateOptionId.event);
    }
    
    let CREATE_OPTIONS: {
      id: CreateOptionId;
      text: string;
      description: string;
      iconName: Icons;
      url?: string;
      onClick?: Function;
      showNewLabel?: boolean;
      render?: () => React.ReactNode;
    }[] = [
      {
        id: CreateOptionId.event,
        text: 'Event',
        description: 'Sell tickets, collect RSVPs, and more.',
        iconName: Icons.calendarPlus,
        url: `/events/new${Boolean(selectedFeed) ? `?cid=${get(selectedFeed, 'id')}` : ''}`,
      },
      {
        id: CreateOptionId.post,
        text: 'Post',
        description: 'Interact with people near you.',
        iconName: Icons.grid,
        onClick: () => {
          // navigation.navigate(Screens.UpdatePost, {
          //   selectedThread: selectedFeed,
          //   previousScreen,
          //   previousScreenProps,
          // });
        },
        render: () => (
          <CreateFeedPostDrawerButton
            // selectedThread={event}
            render={(onClick) => (
              <Dropdown.Item key="communities" className="d-flex align-items-center pt-3 pb-3" onClick={onClick}>
                <div className="bm-Navbar__dropdownMenuIcon">
                  <Icon name={Icons.grid} size={24} />
                </div>
                <div>
                  <p className="text-white mb-1 m-0 p-0">Post</p>
                  <p className="bm-Text--secondaryText m-0 p-0">Interact with people near you.</p>
                </div>
              </Dropdown.Item>
            )}
          />
        ),
      },
    ];

    // if (profileType === 'user') {
    //   CREATE_OPTIONS.push({
    //     id: CreateOptionId.plan,
    //     text: 'Plan',
    //     description: 'Hang out with friends and locals IRL.',
    //     iconName: Icons.calendarDates,
    //     onClick: () => {
    //       // if (selectedFeed) {
    //       //   navigation.navigate(Screens.UpdateActivity, {
    //       //     activity: cleanObject({
    //       //       ...activityTemplate,
    //       //       name: undefined,
    //       //       description: undefined,
    //       //       placeholderName: activityTemplate.name,
    //       //       placeholderDescription: activityTemplate.description,
    //       //       date: get(selectedFeed, 'date'),
    //       //       location: {
    //       //         ...get(selectedFeed, 'location'),
    //       //         name: get(selectedFeed, 'venue.name'),
    //       //       },
    //       //       images: [get(selectedFeed, 'images[0]')],
    //       //       events: {
    //       //         items: [selectedFeed],
    //       //       },
    //       //       tracks: {
    //       //         ...get(selectedFeed, 'tracks'),
    //       //         items: [get(selectedFeed, 'tracks.items[0]')],
    //       //       },
    //       //     }),
    //       //   });
    //       // } else {
    //       //   navigation.navigate(Screens.SelectActivityEvent, { activityTemplate });
    //       // }
    //     },
    //   });
    // }

    // TODO: Uncomment when ready
    if (profileType === 'artist') {
      // CREATE_OPTIONS.push({
      //   id: CreateOptionId.gig,
      //   text: 'Gig',
      //   description: 'Promote your upcoming gigs.',
      //   iconName: Icons.microphone,
      //   showNewLabel: true,
      //   render: () => (
      //     <CreateGigButton
      //       artist={profile as Artist}
      //       render={(onClick) => (
      //         <Dropdown.Item key="gigs" className="d-flex align-items-center pt-3 pb-3" onClick={onClick}>
      //           <div className="bm-Navbar__dropdownMenuIcon">
      //             <Icon name={Icons.microphone} size={24} />
      //           </div>
      //           <div>
      //             <p className="text-white mb-1 m-0 p-0">Gig</p>
      //             <p className="bm-Text--secondaryText m-0 p-0">Promote your upcoming gigs.</p>
      //           </div>
      //         </Dropdown.Item>
      //       )}
      //     />
      //   ),
      // });
    }

    CREATE_OPTIONS = CREATE_OPTIONS.filter(({ id }) => !hiddenOptions.includes(id));

    return (
      <Button
        variant="primary"
        className="btn btn-primary d-flex align-items-center"
        role="button"
        style={{ borderRadius: 100 }}
        dropdownClassName="bm-Navbar__dropdownMenu"
        dropdownItems={CREATE_OPTIONS.map(({ id, text, description, iconName, url, onClick, render }) => Boolean(render) ? render!() : (
          <Dropdown.Item
            key={id}
            className="d-flex align-items-center pt-3 pb-3"
            onClick={Boolean(onClick) ? onClick as any : (e) => {
              if (e && e.preventDefault) {
                e.preventDefault();
                e.stopPropagation();
              }
              history.push(url);
            }}
          >
            <div className="bm-Navbar__dropdownMenuIcon mr-3">
              <Icon name={iconName} size={22} />
            </div>
            <div>
              <p className="text-white mb-1 m-0 p-0">{text}</p>
              {Boolean(description) && (
                <p className="bm-Text--secondaryText m-0 p-0">{description}</p>
              )}
            </div>
          </Dropdown.Item>
        ))}
      >
        <Icon name={Icons.plus} className="bm-Icon--white mr-1" size={22} />
        <span className="mr-1">Create</span>
        <Icon name={Icons.chevronDown} className="bm-Icon--white" size={18} />
      </Button>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  currentUser: getCurrentUser(state),
  currentProfile: getCurrentProfile(state),
});

export default connect(mapStateToProps)(withRouter<any, any>(CreateButton));